<template>
  <div class="aena"
        v-dragscroll.y
        style="overflow-y:scroll;"
  >
    <table
      cellspacing="0"
      cellpadding="0"
      style="height: calc(100vh);"
    >
      <tr v-if="isBanner" style="position: fixed;padding:0px;">
        <td colspan="8">
              <v-img :key="banner" :src="banner" style="width:1090px !important; height: auto;" />
        </td>
      </tr>
      <tr class="title"
        :style="{ 'margin-top': isBanner ? '200px' : null}"
      >
        <td>
          <v-layout wrap style="width:1080px;padding: 20px 20px;" class="title">
            <v-flex xs6 style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;">
              <v-layout wrap>
                <v-flex xs6 v-if="isGranCanaria"
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'sur' ? '100%' : '50%' }"
                  @click="handleGetData('granCanaria')"
                  :class="type === 'sur' ? 'active' : 'no-active'"
                >
                  Gran Canaria
                </v-flex>
                <v-flex xs6 v-if="isGranCanaria">
                </v-flex>
                <v-flex xs6 v-if="isPalmaDeMallorca"
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'sur' ? '100%' : '50%' }"
                  @click="handleGetData('palmaDeMallorca')"
                  :class="type === 'sur' ? 'active' : 'no-active'"
                >
                  Palma de Mallorca
                </v-flex>
                <v-flex xs6 v-if="isPalmaDeMallorca">
                </v-flex>
                <v-flex xs6 v-if="isIbiza"
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'sur' ? '100%' : '50%' }"
                  @click="handleGetData('ibiza')"
                  :class="type === 'sur' ? 'active' : 'no-active'"
                >
                  Ibiza
                </v-flex>
                <v-flex xs6 v-if="isIbiza">
                </v-flex>
                <v-flex xs6 v-if="isMenorca"
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'sur' ? '100%' : '50%' }"
                  @click="handleGetData('menorca')"
                  :class="type === 'sur' ? 'active' : 'no-active'"
                >
                  Menorca
                </v-flex>
                <v-flex xs6 v-if="isMenorca">
                </v-flex>
                <v-flex xs6 v-if="isFuerteventura"
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'sur' ? '100%' : '50%' }"
                  @click="handleGetData('lanzarote')"
                  :class="type === 'sur' ? 'active' : 'no-active'"
                >
                  Fuerteventura
                </v-flex>
                <v-flex xs6 v-if="isFuerteventura">
                </v-flex>
                <v-flex xs6 v-if="isLanzarote"
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'sur' ? '100%' : '50%' }"
                  @click="handleGetData('lanzarote')"
                  :class="type === 'sur' ? 'active' : 'no-active'"
                >
                  Lanzarote
                </v-flex>
                <v-flex xs6 v-if="isLanzarote">
                </v-flex>
                <v-flex xs6 v-if="!isLanzarote && !isFuerteventura && !isGranCanaria && !isPalmaDeMallorca && !isIbiza && !isMenorca"
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'sur' ? '100%' : '50%' }"
                  @click="handleGetData('sur')"
                  :class="type === 'sur' ? 'active' : 'no-active'"
                >
                  Tenerife Sur 
                  <!--small style="font-size: 0.7rem;text-transform: lowercase;">{{ getTranslation({ es: 'actualizado a las ', en: 'updated: ' }, locale) }}{{prepareLMD(LMD, locale)}}</small-->
                </v-flex>
                <v-flex xs6 v-if="!isLanzarote && !isFuerteventura && !isGranCanaria && !isPalmaDeMallorca && !isIbiza && !isMenorca"
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'norte' ? '100%' : '50%' }"
                  @click="handleGetData('norte')"
                  :class="type === 'norte' ? 'active' : 'no-active'"
                >
                  Tenerife Norte 
                  <!--small style="font-size: 0.7rem;text-transform: lowercase;">{{ getTranslation({ es: 'actualizado a las ', en: 'updated: ' }, locale) }}{{prepareLMD(LMD, locale)}}</small-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 style="text-align:right;padding-right:20px;font-weight:700;font-family: MontserratBold, sans-serif !important;">

              <small style="font-size: 0.7rem;text-transform: lowercase;margin-right: 20px;">{{ getTranslation({ es: 'actualizado a las ', en: 'updated: ' }, locale) }}{{prepareLMD(LMD, locale)}}</small>
              <v-icon color="#525c65" style="margin: -5px 10px 0 0;">mdi-airplane-takeoff</v-icon> {{getTranslation({ es: 'salidas', en: 'departures' }, locale)}}
            </v-flex>
          </v-layout>
        </td>
        <!--td colspan="4" style="width:50%;">
          <v-icon color="#525c65">mdi-airplane-takeoff</v-icon> Salidas
        </td-->
      </tr>
      <tr 
        class="sticky"
        :style="{ 'margin-top': isBanner ? '275px' : null}"
      >
        <!--th class="date">
          Fecha
        </th-->
        <th class="time">
          {{getTranslation({ es: 'hora', en: 'time' }, locale)}}
        </th>
        <th class="flightNumber">
          {{getTranslation({ es: 'vuelo', en: 'flight' }, locale)}}
        </th>
        <th class="company">
          {{getTranslation({ es: 'Compañía', en: 'company' }, locale)}}
        </th>
        <th class="destination">
          {{getTranslation({ es: 'destino', en: 'destination' }, locale)}}
        </th>
        <th class="terminal">
          terminal
        </th>
        <!--th class="checkin">
          Mostrador de Facturación
        </th-->
        <th class="gate">
          {{getTranslation({ es: 'puerta', en: 'gate' }, locale)}}
        </th>
        <th class="state">
          {{getTranslation({ es: 'estado', en: 'state' }, locale)}}
        </th>
      </tr>
      <tr style="height:120px"
        :style="{ 'height': isBanner ? '300px' : '120px'}"
      >
      </tr>
      <tr 
        v-for="(departure, index) of departures"
        :key="index"
      >
        <!--td class="date">
          {{departure.fechaEstimada}} 
        </td-->
        <td class="time">
          {{ prepareTime(departure.horaEstimada) }}
        </td>
        <td class="flightNumber">
          {{departure.compania}}{{departure.numVuelo}}
        </td>
        <td class="company">
          <img v-if="prepareURL(departure && departure.urlLogoCompaniaDesktopMin1600)"
            :src="prepareURL(departure && departure.urlLogoCompaniaDesktopMin1600)"
          />
          <small v-else>{{departure.nombreCompania}}</small>
        </td>
        <td class="destination">
          {{ departure.ciudadIataOtro }}
        </td>
        <td class="terminal">
          {{ departure.terminal }}
        </td>
        <!--td class="checkin">
          {{departure.mostradorDesde}} - {{ departure.mostradorHasta }}
        </td-->
        <td class="gate">
          {{ prepareGate(departure)}}
        </td>
        <td 
          class="state"
          :style="{
            color: departure.estado === 'RET' || departure.estado === 'ULL' ? 'red'
                  : departure.estado === 'EMB' ? 'green' : 'black'
          }">
          {{ prepareState(departure.estado, locale) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
//import bannerES from '@/assets/banner_transfer_es.jpg'
//import bannerEN from '@/assets/banner_transfer_en.jpg'
import bannerES from '@/assets/transferes02.jpg'
import bannerEN from '@/assets/transferen02.jpg'
import { dragscroll } from 'vue-dragscroll'
import axios from 'axios'
import utils from '@/services/utils'
export default {
  name: 'HomeView',
  directives: {
    dragscroll
  },
  props: {
    enterprise: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    isLanzarote: {
      type: Boolean,
      default: false,
    },
    isFuerteventura: {
      type: Boolean,
      default: false,
    },
    isGranCanaria: {
      type: Boolean,
      default: false,
    },
    isPalmaDeMallorca: {
      type: Boolean,
      default: false,
    },
    isIbiza: {
      type: Boolean,
      default: false,
    },
    isMenorca: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    type: 'sur',
    LMD: null,
    departures: null,
    states: {
      INI: { 'es': ' ', 'en': ' ' },
      SCH: { 'es': ' ', 'en': ' ' },
      ULL: { 'es': 'Ult.Llamada', 'en': 'Last Call' },
      RET: { 'es': 'Restrasado', 'en': 'Delayed' },
      EMB: { 'es': 'Embarcado', 'en': 'Boarding' },
    },
    banner: bannerES,
  }),
  computed: {
    row () {
      const params = new URLSearchParams(window.location.search)
      const aux = params.get('row')
      return aux ? aux | 0 : 30
    },
    isBanner () {
      return this.enterprise && (this.enterprise.ID === '77e5e123-da2b-438f-b944-7a424f712a9e' || this.enterprise.ID === '0ea3791f-2308-47d1-8a87-f91ab2cf205d' || this.enterprise.ID === '72c0948f-7eef-4d82-ab84-f94862c7a37f') ? true : false
    },
  },
  watch: {
    locale () {
      this.prepareBanner()
    },
  },
  mounted () {
    this.prepareBanner()
    this.getDepartures()
  },
  methods: {
    prepareURL (v) {
      if (!v || v === undefined || v === '' || `https://www.aena.es/${v}` === 'https://www.aena.es/null') return null
      return `https://www.aena.es/${v}`
    },
    prepareBanner () {
      this.banner = this.locale === 'es' ? bannerES : bannerEN
    },
    handleGetData (v) {
      this.type = v
      this.getDepartures()
    },
    prepareLMD (v, locale) {
      if (!v) return null
      return v.toLocaleTimeString(locale)
    },
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    getDepartures () {
      axios.get(`https://cm-dviewcontent-api.dviewcontent.com/v1/public/aena/departures/${
              this.isLanzarote ? 'lanzarote' : 
              this.isFuerteventura ? 'fuerteventura' : 
              this.isGranCanaria ? 'granCanaria' : 
              this.isPalmaDeMallorca ? 'palmaDeMallorca' : 
              this.isIbiza ? 'ibiza' : 
              this.isMenorca ? 'menorca' : 
              this.type}`)
        .then(response => {
          this.LMD = new Date(response.data.LMD)
          this.departures = response.data.data.slice(0, this.row)
        })
    },
    prepareGate(v) {
      if (v.puertaPrimera !== 'null') return v.puertaPrimera
      if (v.puertaSegunda !== 'null') return v.puertaSegunda
      return ''
    },
    prepareTime (v) {
      const aux = v.split(':')
      return `${aux[0]}:${aux[1]}`
    },
    prepareState (v, locale) {
      return this.states[v] ? this.getTranslation(this.states[v], locale) : v
    }
  }
}
</script>

<style scoped>
th {
  color: white;
  padding: 10px 0;
}
* {
  font-weight: 500;
}
table {
  width: 100%;
  text-transform: uppercase;
}
img {
  height: 40px;
  width: auto;
}
td {
  text-align: center;
  padding: 0 10px;
}
.sticky {
  margin-top:70px;
  position:fixed;
  width:100%;
  font-size: 0.6rem;
  background-color: #525c65;
  /*
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  */
}
.aena {
  height: 100%;
  overflow-y: scroll;
  font-family: MontserratRegular, sans-serif !important;
}
.aena .active {
  color: #525c65;
}
.aena .no-active {
  color: #525c6580;
}
.aena .title {
  position:fixed;
  width:100%;
  color: #525c65;
  background-color: white;
  font-weight:700 !important;
  font-family: MontserratBold, sans-serif !important;
}
.aena .date {
  width: 25px;
}
.aena .time {
  width: 140px;
}
.aena .flightNumber {
  width: 92px;
}
.aena .company {
  width: 116px;
}
.aena .destination {
  width: 358px;
}
.aena .terminal {
  width: 64px;
}
.aena .checkin {
  width: 143px;
}
.aena .gate {
  width: 72px;
}
.aena .state {
  padding: 10px;
  width: 236px;
}
</style>


